import moment from 'moment';

export const weekdaysBetween =(d1: any, d2: any, isoWeekday: any) => {
    // ensure we have valid moment instances
    d1 = moment(d1.startOf('day'));
    d2 = moment(d2.endOf('day'));
    // figure out how many days to advance to get to the next
    // specified weekday (might be 0 if d1 is already the 
    // specified weekday).
    var daysToAdd = ((7 + isoWeekday) - d1.isoWeekday()) % 7;
    var nextTuesday = d1.clone().add(daysToAdd, 'days');
    // if we are already passed the end date, there must not
    // be any of that day in the given period.
    if (nextTuesday.isAfter(d2)) {
        return 0;
    }
    // otherwise, just return the whole number of weeks
    // difference plus one for the day we already advanced to
    var weeksBetween = d2.diff(nextTuesday, 'weeks');
    return weeksBetween + 1;
}

export const workingDaysCount = (fromDate: any, toDate: any, holidays: any[]) =>{
    // console.log("fromDate, toDate: ",fromDate, toDate);
    if(fromDate._isAMomentObject == true && fromDate._isAMomentObject == true){
      let numberOfDays = moment(toDate).diff(fromDate, 'days') + 1; //1 added to include the first date.

      //Count sundays and saturdays in the date range
      let sundaysInRange = weekdaysBetween(fromDate, toDate, 7);
      let saturdaysInRange = weekdaysBetween(fromDate, toDate, 6);

      //Holidays
      let numberOfHolidays = holidaysInDateRange(fromDate, toDate, holidays);

      console.log("Sundays in range:", sundaysInRange); 
      console.log("Saturdays in range:", saturdaysInRange);
      console.log("Number of holidays in range: ", numberOfHolidays);

      //Remove sundays and saturdays(half) from range
      numberOfDays = (numberOfDays - sundaysInRange) - (saturdaysInRange*0.5)
      //Remove holidays from range
      //   console.log("holidays from state: ", this.state.numberOfHolidays);
     
      if(numberOfHolidays > 0){
        numberOfDays = numberOfDays - numberOfHolidays;
      }
      
      console.log("Working days days minus weekends and holidays: ", numberOfDays)

      return numberOfDays
    }
  }

  export const holidaysInDateRange = (fromDate: any, toDate: any, holidays: any[]) => {
    //get list of available holidays.
    // await this.fetchHolidays();

    // const holidays = this.state.holidays;
    console.log("Holidays", holidays)
    let numberOfDaysInRange = moment(toDate).diff(fromDate, 'days') + 1; 
    let dateInRange = fromDate;
    let datesInRange = [];
    let numberOfHolidaysInDateRange = 0;

    // console.log("number of days in range: ", numberOfDaysInRange);
    
     for (let dateIndex = 0; dateIndex < numberOfDaysInRange; dateIndex++) {
      console.log("date in range: ", dateInRange);
      // datesInRange.push(dateInRange);

      //for each date in the provided date range, check if its in the holiday date range
        for (let holidayIndex = 0; holidayIndex < holidays.length; holidayIndex++) {
          let holidayFromDate =  moment(holidays[holidayIndex].fromDate).startOf('day');
          let holidayToDate =  moment(holidays[holidayIndex].toDate).endOf('day');
        //   console.log("Holiday From, To: ", holidayFromDate, holidayToDate);
        //   console.log("day in provided date range:",dateInRange.day()) // 0123456 -beginning from saturday
          
          if(dateInRange.isBetween(holidayFromDate, holidayToDate, 'days', '[]')){ //'[]' means the start and end dates are all inclusive
          console.log("Date is in range!!!!!!!!!!");
            if(dateInRange.day() === 6){ // 6 is saturday
              console.log("saturday detected in holiday calculation!", dateInRange.day())
              numberOfHolidaysInDateRange += 0.5
            } else if (dateInRange.day() !== 6 && dateInRange.day() !== 0){ //0 is sunday
              console.log("normal day detected in holiday calculation!", dateInRange.day()) 
              numberOfHolidaysInDateRange += 1;
            }
          }
        }

        dateInRange = moment(dateInRange).add(1, 'day');
    }

    console.log("Number of holidays in provided range: ", numberOfHolidaysInDateRange);
    return numberOfHolidaysInDateRange;
  }



  export const holidaysListInDateRange = (fromDate: any, toDate: any, holidays: any[]) => {

    let numberOfDaysInRange = moment(toDate).diff(fromDate, 'days') + 1; 
    let dateInRange = fromDate;
    let holidaysInDateRange = [];

     for (let dateIndex = 0; dateIndex < numberOfDaysInRange; dateIndex++) {

      //for each date in the provided date range, check if its in the holiday date range
        for (let holidayIndex = 0; holidayIndex < holidays.length; holidayIndex++) {
          let holidayFromDate =  moment(holidays[holidayIndex].fromDate).startOf('day');
          let holidayToDate =  moment(holidays[holidayIndex].toDate).endOf('day');

          if(dateInRange.isBetween(holidayFromDate, holidayToDate, 'days', '[]')){ //'[]' means the start and end dates are all inclusive
            if(dateInRange.day() === 6){ // 6 is saturday
              holidaysInDateRange.push({'holidayDate': dateInRange, 'holidayName': holidays[holidayIndex].holidayName});
            } else if (dateInRange.day() !== 6 && dateInRange.day() !== 0){ //0 is sunday
              holidaysInDateRange.push({'holidayDate': dateInRange, 'holidayName': holidays[holidayIndex].holidayName});
            }
          }
        }

        dateInRange = moment(dateInRange).add(1, 'day');
    }
    console.log("Holidays list in provided date range: ", holidaysInDateRange);
    return holidaysInDateRange;
  }